module.exports = __webpack_public_path__ + "img/back_btn.e908686d.png";